import React, { ReactNode } from 'react';
import { useFormStyles } from '../styles';

interface LabeledFieldProps {
  label: string;
  required?: boolean;
  hint?: ReactNode;
  fullWidth?: boolean;
  children: ReactNode;
}

export const LabeledField = ({
  label,
  required,
  hint,
  fullWidth,
  children,
}: LabeledFieldProps) => {
  const classes = useFormStyles();
  return (
    <div className={`${classes.field} ${fullWidth ? classes.fieldFull : ''}`}>
      <span className={classes.label}>
        {label}
        {required && <span className={classes.required}>*</span>}
      </span>
      {children}
      {hint && <p className={classes.hint}>{hint}</p>}
    </div>
  );
};

interface TextInputProps {
  value: string | number;
  onChange?: (value: string) => void;
  type?: string;
  placeholder?: string;
  disabled?: boolean;
  style?: React.CSSProperties;
}

export const TextInput = ({
  value,
  onChange,
  type = 'text',
  placeholder,
  disabled,
  style,
}: TextInputProps) => {
  const classes = useFormStyles();
  return (
    <input
      className={classes.input}
      type={type}
      value={value}
      placeholder={placeholder}
      disabled={disabled}
      style={style}
      onChange={(event) => onChange?.(event.target.value)}
    />
  );
};

interface SelectOption {
  id: string;
  name: string;
  disabled?: boolean;
}

interface SelectInputProps {
  value: string;
  onChange?: (value: string) => void;
  options: SelectOption[];
  disabled?: boolean;
  style?: React.CSSProperties;
}

export const SelectInput = ({
  value,
  onChange,
  options,
  disabled,
  style,
}: SelectInputProps) => {
  const classes = useFormStyles();
  return (
    <select
      className={classes.input}
      value={value}
      disabled={disabled}
      style={style}
      onChange={(event) => onChange?.(event.target.value)}
    >
      {options.map((option) => (
        <option key={option.id} value={option.id} disabled={option.disabled}>
          {option.name}
        </option>
      ))}
    </select>
  );
};
